import { Theme } from '@mui/material'

export const inputContainerStyle = (
  sizeContainer: 'auto' | 'small'
): any => ({
  width: sizeContainer === 'auto' ? 'auto' : 'small'
})

export const inputLabelStyle = (enabled?: boolean): any => ({
  color: enabled ? 'text.primary' : 'text.disabled'
})

export const iconButtonStyle: any = {
  color: '#006BEE'
}

export const errorLabelStyle: any = {
  color: 'error.main'
}
